import { FaFileDownload ,FaLink} from "react-icons/fa";
import { MdFileOpen, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";
import { INDUSTRIES } from "../Services/contants/minimumWages";

const IndustriesDataTable = ({
  data = [],
  state = "",
  classNames = "",
  showActions = false,
  showIndustryType = false,
  onEdit = () => {},
  onDelete = () => {},
}) => {
   const latestUpdatedIndex = data.reduce((latestIndex, current, index, array) => {
    const currentUpdated = new Date(current.updatedAt);
    const latestUpdated = new Date(array[latestIndex]?.updatedAt || 0);
    return currentUpdated > latestUpdated ? index : latestIndex;
  }, 0);
  return (
    <div className={`mt-6 overflow-x-auto w-full ${classNames}`}>
      <h2 className="text-xl text-primary-color font-semibold">{state}</h2>
      <table className="w-full text-sm border-0">
        <thead className="bg-dark text-white">
          <tr>
            <th className="text-center font-semibold border-0">Upload Date</th>
            <th className="text-center font-semibold border-0">Effective From</th>
            <th className="text-center font-semibold border-0">Effective To</th>
            <th className="text-center font-semibold border-0">Notified On</th>
            <th className="text-center font-semibold border-0">Notification Number</th>
            <th className="text-center font-semibold border-0">File Actions</th>
            <th className="text-center font-semibold border-0">Notification Link</th>
            {showIndustryType && <th className="text-center font-semibold border-0">Industry</th>}
            {showIndustryType && <th className="text-center font-semibold border-0">Year</th>}
            {showActions && <th className="text-center font-semibold border-0">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 text-center text-gray-700 border-0 text-nowrap flex gap-1">
                <div>
                  {index === latestUpdatedIndex && (
                  <span className="ml-2 text-xs font-semibold text-white bg-green-600 px-1 py-0.5 rounded-full ">NEW</span>
                )}
                </div>
                <div>
                  {item.updatedAt
                  ? new Date(item.updatedAt)
                      .toISOString()
                      .split('T')[0]
                      .split('-')
                      .reverse()
                      .join('-')
                  : 'N/A'
                  }
                  </div>
              </td>


              <td className="px-6 py-4 text-center text-gray-700 border-0 text-nowrap">
                {item.EffectiveFrom && !isNaN(new Date(item.EffectiveFrom)) ? (
                  <span>{new Date(item.EffectiveFrom).toISOString().split('T')[0].split('-').reverse().join('-')}</span>
                ) : (
                  'N/A'
                )}
              </td>
              <td className="px-6 py-4 text-center text-nowrap text-gray-700 border-0">{item.EffectiveTo && !isNaN(new Date(item.EffectiveTo)) ? (
                  <span>{new Date(item.EffectiveTo).toISOString().split('T')[0].split('-').reverse().join('-')}</span>
                ) : (
                  'N/A'
                )}
              </td>
              <td className="px-8 py-4 text-center text-nowrap text-gray-700 border-0">{item.NotifiedOn && !isNaN(new Date(item.NotifiedOn)) ? (
                <span>{new Date(item.NotifiedOn).toISOString().split('T')[0].split('-').reverse().join('-')}</span>
                ) : (
                  'N/A'
                )}
              </td>
              <td
                  className="px-6 py-4 text-center text-nowrap text-gray-700 border-0"
                  title={item.NotificationNo.length > 15 ? item.NotificationNo : ''}
                >
                  {item.NotificationNo.length > 15
                    ? `${item.NotificationNo.substring(0, 15)}...`
                    : item.NotificationNo}
                </td>


              <td className="px-6 py-4 border-0 text-nowrap">
                <div className="flex gap-2 justify-center">
                 
                  <a
                    href={`https://docs.google.com/gview?url=${item.fileUrl}&embedded=true`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex gap-2 items-center px-1 py-1 text-sm"
                  >
                    <MdFileOpen className="text-lg text-green-600" />
                    <span>View</span>
                  </a>
                   <a
                    href={item.fileUrl}
                    target="_blank"
                    download
                    rel="noopener noreferrer"
                    className="flex gap-2 items-center px-1 py-1 text-sm"
                  >
                    <FaFileDownload className="text-base text-blue-600" />
                    <span>Download</span>
                  </a>
                </div>
              </td>

              <td className="px-6 py-4 text-center border-0 text-nowrapx">
                {item.referenceLink?.trim().toLowerCase() !== 'n/a' && item.referenceLink?.trim() !== '' ? (
                  <a
                    href={item.referenceLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex gap-2 items-center justify-center px-1 py-1 text-sm "
                  >
                                              <FaLink className="text-red-600 hover:text-red-800" />
                    
                    
                  </a>
                ) : (
                  <span className="text-black">N/A</span>
                )}
              </td>

              {showIndustryType && (
                <td className="px-6 py-4 text-center border-0">{INDUSTRIES.getNameById(item.industryType)}</td>
              )}

              {showIndustryType && (
                <td className="px-6 py-4 text-center border-0">{item.year}</td>
              )}

              {showActions && (
                <td className="px-6 py-4 text-center border-0 ">
                  <div className="flex justify-center gap-2">
                    {/* <button
                      onClick={() => onView(item)}
                      className="px-2 py-1 border border-gray-400 rounded hover:bg-gray-100"
                      title="View"
                    >
                      <MdRemoveRedEye className="text-xl text-gray-700" />
                    </button> */}
                    <button
                      onClick={() => onEdit(item)}
                      className="px-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                      title="Edit"
                    >
                      <MdEditDocument className="text-lg text-blue-600" />
                    </button>
                    <button
                      onClick={() => onDelete(item.id)}
                      className="px-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                      title="Delete"
                    >
                      <MdDelete className="text-lg text-red-600" />
                    </button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IndustriesDataTable;
